import Vue from 'vue';
import { Carousel3d, Slide } from 'vue-carousel-3d';

export default () => {
  Vue.component('carousel-3d', Carousel3d);
  Vue.component('slide', Slide);
};
